import { render, staticRenderFns } from "./_ActionBar.vue?vue&type=template&id=0acb72b4&"
import script from "./_ActionBar.vue?vue&type=script&lang=ts&"
export * from "./_ActionBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0acb72b4')) {
      api.createRecord('0acb72b4', component.options)
    } else {
      api.reload('0acb72b4', component.options)
    }
    module.hot.accept("./_ActionBar.vue?vue&type=template&id=0acb72b4&", function () {
      api.rerender('0acb72b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/navbar/_ActionBar.vue"
export default component.exports